import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SelectLabels from './SelectLabels';
import ClientProvider from './client';
export default createDemo(import.meta.url, SelectLabels, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/selects/demos/labels/SelectLabels.tsx",
    "fileName": "SelectLabels.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport InputLabel from '@mui/material/InputLabel';\nimport MenuItem from '@mui/material/MenuItem';\nimport FormHelperText from '@mui/material/FormHelperText';\nimport FormControl from '@mui/material/FormControl';\nimport Select from '@mui/material/Select';\nimport type { SelectChangeEvent } from '@mui/material/Select';\n\nexport default function SelectLabels() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const id = React.useId();\n  const noLabelId = React.useId();\n  const [age, setAge] = React.useState('');\n\n  const handleChange = (event: SelectChangeEvent) => {\n    setAge(event.target.value);\n  };\n\n  return (\n    <div>\n      <FormControl sx={{ m: 1, minWidth: 120 }}>\n        <InputLabel id={`${id}-label`}>Age</InputLabel>\n        <Select\n          aria-describedby={`${id}-helper-text`}\n          labelId={`${id}-label`}\n          id={id}\n          value={age}\n          label=\"Age\"\n          onChange={handleChange}\n        >\n          <MenuItem value=\"\">\n            <em>None</em>\n          </MenuItem>\n          <MenuItem value={10}>Ten</MenuItem>\n          <MenuItem value={20}>Twenty</MenuItem>\n          <MenuItem value={30}>Thirty</MenuItem>\n        </Select>\n        <FormHelperText id={`${id}-helper-text`}>\n          Visible label and helper text\n        </FormHelperText>\n      </FormControl>\n      <FormControl sx={{ m: 1, minWidth: 120 }}>\n        <Select\n          aria-describedby={`${noLabelId}-helper-text`}\n          value={age}\n          onChange={handleChange}\n          displayEmpty\n          inputProps={{ 'aria-label': 'Age' }}\n        >\n          <MenuItem value=\"\">\n            <em>None</em>\n          </MenuItem>\n          <MenuItem value={10}>Ten</MenuItem>\n          <MenuItem value={20}>Twenty</MenuItem>\n          <MenuItem value={30}>Thirty</MenuItem>\n        </Select>\n        <FormHelperText id={`${noLabelId}-helper-text`}>\n          aria-label and helper text\n        </FormHelperText>\n      </FormControl>\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 62,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport InputLabel from '@mui/material/InputLabel';\nimport MenuItem from '@mui/material/MenuItem';\nimport FormHelperText from '@mui/material/FormHelperText';\nimport FormControl from '@mui/material/FormControl';\nimport Select from '@mui/material/Select';\nimport type { SelectChangeEvent } from '@mui/material/Select';\n\nexport default function SelectLabels() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const id = React.useId();\n  const noLabelId = React.useId();\n  const [age, setAge] = React.useState('');\n\n  const handleChange = (event: SelectChangeEvent) => {\n    setAge(event.target.value);\n  };\n\n  return (\n    <div>\n      <FormControl sx={{ m: 1, minWidth: 120 }}>\n        <InputLabel id={`${id}-label`}>Age</InputLabel>\n        <Select\n          aria-describedby={`${id}-helper-text`}\n          labelId={`${id}-label`}\n          id={id}\n          value={age}\n          label=\"Age\"\n          onChange={handleChange}\n        >\n          <MenuItem value=\"\">\n            <em>None</em>\n          </MenuItem>\n          <MenuItem value={10}>Ten</MenuItem>\n          <MenuItem value={20}>Twenty</MenuItem>\n          <MenuItem value={30}>Thirty</MenuItem>\n        </Select>\n        <FormHelperText id={`${id}-helper-text`}>\n          Visible label and helper text\n        </FormHelperText>\n      </FormControl>\n      <FormControl sx={{ m: 1, minWidth: 120 }}>\n        <Select\n          aria-describedby={`${noLabelId}-helper-text`}\n          value={age}\n          onChange={handleChange}\n          displayEmpty\n          inputProps={{ 'aria-label': 'Age' }}\n        >\n          <MenuItem value=\"\">\n            <em>None</em>\n          </MenuItem>\n          <MenuItem value={10}>Ten</MenuItem>\n          <MenuItem value={20}>Twenty</MenuItem>\n          <MenuItem value={30}>Thirty</MenuItem>\n        </Select>\n        <FormHelperText id={`${noLabelId}-helper-text`}>\n          aria-label and helper text\n        </FormHelperText>\n      </FormControl>\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 62,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/InputLabel",
      "@mui/material/MenuItem",
      "@mui/material/FormHelperText",
      "@mui/material/FormControl",
      "@mui/material/Select"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
